var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateInstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.8 144.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 56094"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.69 5.02H10.3A10.25 10.25 0 0 0 0 15.26V133.9a10.55 10.55 0 0 0 10.3 10.62h49.36c5.7 0 10.06-4.89 10.06-10.62V15.26A10 10 0 0 0 59.69 5.02ZM30.2 12.18h9.34a1.25 1.25 0 0 1 0 2.49H30.2a1.25 1.25 0 1 1 0-2.5Zm4.83 127.66a5.42 5.42 0 1 1 5.42-5.42 5.42 5.42 0 0 1-5.42 5.42Zm29.11-15.26H5.61a.63.63 0 0 1-.63-.62V21.52a.63.63 0 0 1 .63-.62h58.53a.63.63 0 0 1 .62.62v102.44a.63.63 0 0 1-.62.62Z",
    "data-name": "Icon ionic-ios-phone-portrait",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8 134.45V85.07a10.25 10.25 0 0 0-10.25-10.3H96.92a10.55 10.55 0 0 0-10.62 10.3v49.35c0 5.7 4.9 10.06 10.62 10.06h118.63a10 10 0 0 0 10.25-10.03Zm-7.16-29.48v9.34a1.25 1.25 0 0 1-2.5 0v-9.34a1.25 1.25 0 1 1 2.5 0Zm-127.66 4.82a5.42 5.42 0 1 1 5.41 5.42 5.42 5.42 0 0 1-5.42-5.42Zm15.25 29.12V80.37a.63.63 0 0 1 .63-.62H209.3a.63.63 0 0 1 .62.62v58.54a.63.63 0 0 1-.62.62H106.86a.63.63 0 0 1-.63-.62Z",
    "data-name": "Icon ionic-ios-phone-portrait"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.63 64.61a3 3 0 0 1-2.96-3.52c.16-.95 3.75-23.5-24.47-42.3C118.3-.44 87.42 7.83 87.1 7.92a3 3 0 1 1-1.6-5.78c1.37-.38 33.87-9.08 65.03 11.67 31.65 21.09 27.24 47.26 27.04 48.36a3 3 0 0 1-2.94 2.45Z",
    "data-name": "Path 67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74 66.42h-.06c-1.53-.05-3.11-.1-11.83-13.95a3 3 0 0 1 5.07-3.2 127.96 127.96 0 0 0 7.34 10.62.98.98 0 0 0 .06-.05c1.58-1.56 4.89-7.2 6.6-10.4a3 3 0 1 1 5.29 2.85c-.5.92-4.94 9.1-7.66 11.8a9.05 9.05 0 0 1-4.81 2.33Z",
    "data-name": "Path 68"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateInstruction);
export default __webpack_public_path__ + "static/media/rotate-instruction.8c9b068a10358cd1f9b2aa0b1feec0ad.svg";
export { ForwardRef as ReactComponent };